import { apiFetch } from './apiFetch';
import type { PnlConfig, PnlConfigSave } from '@salaries/shared';

export interface PnlUnitsResponse {
  config: PnlConfig;
  /** Every Arbox location for the box — the assignable set in the settings UI. */
  locations: string[];
}

export async function getPnlUnits(): Promise<PnlUnitsResponse> {
  return apiFetch<PnlUnitsResponse>('/pnl-units');
}

export async function savePnlUnits(save: PnlConfigSave): Promise<PnlConfig> {
  return apiFetch<PnlConfig>('/pnl-units', {
    method: 'PUT',
    body: JSON.stringify(save),
  });
}
